let isAdBlockDetectedParam: boolean;

const INIT_TIMEOUT = 500;

async function initializeAdblockDetector(): Promise<boolean> {
    return new Promise(resolve => {
        setTimeout(() => {
            const ad = document.getElementById('ad-banner');
            resolve(
                !ad ||
                    ad.offsetHeight === 0 ||
                    ad.offsetParent === null ||
                    getComputedStyle(ad).display === 'none',
            );
        }, INIT_TIMEOUT);
    });
}

export async function isAdBlockDetected() {
    if (typeof isAdBlockDetectedParam === 'undefined') {
        // eslint-disable-next-line require-atomic-updates
        isAdBlockDetectedParam = await initializeAdblockDetector();
    }
    return isAdBlockDetectedParam;
}
